import React, { useEffect } from "react";
import { captureException, composeDataMethods } from "@lululemon/mwa-utils";
import { publicConfig } from "@lululemon/ecom-core";
import {
  useLaunchDarklyFlag,
  getPersonalizationClientId,
} from "@lululemon/mwa-ab-testing/esm/utils/ld-cache";
import { storageKey, personalizationWeatherHost } from "./consts";

// Using a higher scope since there is a double render issue with the platform.
// If the useEffect here stops getting called twice this code can be cleaned up.
let fetchedWeather;
export const fetchWeather = async () => {
  try {
    if (!fetchedWeather) {
      fetchedWeather = await fetch(
        publicConfig?.[personalizationWeatherHost]
      ).then((data) => data.json());
      return fetchedWeather;
    }
    return fetchedWeather;
  } catch (e) {
    captureException(e);
  }
};

export const shouldFetch = () => {
  const storageValue = localStorage.getItem(storageKey);
  if (!storageValue) return true;
  const { fetchedAt } = JSON.parse(storageValue);
  const TIME = 60 * 60 * 1000 * 3; /* ms, 3 hours */
  const diff = new Date() - new Date(fetchedAt);
  return diff > TIME;
};

export default function withWeather() {
  return (Component) => {
    function WithWeather(props) {
      const clientId = getPersonalizationClientId();
      const [flag] = useLaunchDarklyFlag("allow-weather-calls", false, {
        clientId,
      });

      const save = (weather) => {
        const fetchedAt = new Date();
        if (typeof weather === "object") {
          localStorage.setItem(
            storageKey,
            JSON.stringify({
              ...weather,
              fetchedAt,
            })
          );
        }
      };

      const onFocus = async () => {
        if (shouldFetch()) {
          const weather = await fetchWeather();
          // verify the returned object has an important weather point and has a number value
          if (!isNaN(weather?.dailyAvg)) {
            save(weather);
          }
        }
      };

      useEffect(() => {
        if (flag) {
          window.addEventListener("focus", onFocus);
          onFocus();
          return () => {
            window.removeEventListener("focus", onFocus);
          };
        }
      }, [flag]);

      return <Component {...props} />;
    }

    return composeDataMethods(Component)(WithWeather);
  };
}
